import classNames from 'classnames/bind';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../../Base.constants';
import { NoDataDash } from '../../../../../components/formatters';
import { SearchDocumentsDto } from '../../../../../services/dtos/securities/searchDocuments.dto';
import { getArticleId, getSubTabName } from '../../CompanyDocumentsTab.logic';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import { trackDocumentDownload } from '../../../../../utils/trackUsageUtils';

const LoanSecurityRenderer = ({
  show,
  data,
  columnConfig,
  row: { isHovered, isDisabled },
}: GroupedTableRowRendererProps<SearchDocumentsDto>): React.ReactElement | null => {
  if (!show) {
    return null;
  }

  const loanArticleHandler = (articleId: number) => {
    trackDocumentDownload({
      tabName: getSubTabName(window.location.href),
      articleId,
    });
  };

  return (
    <div className={classNames('body', { 'gray-out': isDisabled && isHovered })}>
      {data[columnConfig.dataKey] ? (
        <Link to={ROUTES.article(getArticleId(data))} onClick={() => loanArticleHandler(getArticleId(data))}>
          {data[columnConfig.dataKey]}
        </Link>
      ) : (
        <NoDataDash />
      )}
    </div>
  );
};

export default LoanSecurityRenderer;
